import { render } from "./CasinoComponent.vue?vue&type=template&id=3ad96003&ts=true"
import script from "./CasinoComponent.vue?vue&type=script&lang=ts"
export * from "./CasinoComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__